module.exports = __webpack_public_path__ + "static/media/logo-wordmark.71c84d30.svg";